import SearchableSelect from "../../../../util/component/SearchableSelect";
import React, {useEffect, useState} from "react";
import SearchableSelectAsync from "../../../../util/component/SearchableSelect/async";
import axios from "../../../../util/axios";
import update from "immutability-helper";


const CteateEquis = (props) =>{



    const [ typeList, setTypeList ] = useState([]);
    const [ subTypeList, setSubTypeList ] = useState([]);
    const [ shatingRules, setShatingRules] = useState([]);
    const [ customer, setCustomer] = useState([]);
    const [ equisProcess, setEquisProcess] = useState([]);
    const [ plant, setPlant] = useState([]);
    const [ owningDepartment, setOwningDepartment] = useState([]);
    const [ product, setProduct] = useState([]);

    const {revInfo,PDFDownFunction,createData,setCreateData,project,HandleCreateConfrim} = props;



    const [ subTypePicklist, setSubTypePicklist ] = useState([]);





    useEffect( () => {
        getEquisType()
            .then((res) =>{return res.data.data.result?.find((d) => d.label === "Governance and Procedure")})
            .then((data)=>{
                getEquisSubType(data)
                setCreateData(d => update(d, {
                    equisType: { $merge: { label: data?.label,value: data?.value } },
                    $merge: {name:"" +project.projectNm +" "+(project.processCd === "USP" ? "Upstream " : "Downstream ") + "Process Control Strategy" }
                    }))

            })

        getEquisPicklistByQuery();

    }, [])

    const getEquisType = async () => {
        const uri = '/veeva/retrieveEquisType';
        const response = await axios.post(process.env.REACT_APP_API + uri);
        setTypeList(response.data.data.result ? response.data.data.result : []);

        return response;

    }
    const getEquisPicklistByQuery = async () => {
        const uri = '/veeva/retrieveEquisPicklistByQuery';
        const ProcessResponse = await axios.post(process.env.REACT_APP_API + uri,{value:"process__c"});
        setEquisProcess(ProcessResponse.data.data.result ? ProcessResponse.data.data.result : []);

        const PlantResponse = await axios.post(process.env.REACT_APP_API + uri,{value:"facility__v"});
        setPlant(PlantResponse.data.data.result ? PlantResponse.data.data.result : []);

        const OwningDepartmentResponse = await axios.post(process.env.REACT_APP_API + uri,{value:"department__v"});
        setOwningDepartment(OwningDepartmentResponse.data.data.result ? OwningDepartmentResponse.data.data.result : []);

    }
    const getEquisProductlistByCustomer = async (val) => {
        const uri = '/veeva/retrieveEquisProductlistByCustomer';
        const ProductResponse = await axios.post(process.env.REACT_APP_API + uri,{value:val});
        setProduct(ProductResponse.data.data.result ? ProductResponse.data.data.result : []);

    }


    const getEquisSubType = async (val) => {
        const uri = '/veeva/retrieveEquisSubtype';
        const postData = {
            value: val.value

        }
        await axios.post(process.env.REACT_APP_API + uri, postData)
            .then((res)=>{
                setSubTypeList(res.data.data.result ? res.data.data.result : []);
                return res.data.data.result?.find((d) => d.label === "Process Control Strategy");
            })
            .then((data)=>{
                setCreateData(d => update(d, {
                    equisSubType: { $merge: { label: data?.label,value: data?.value } },
                }))
                getEquisSubTypePick(data);

            });


    }

    const getEquisSubTypePick = async (val) => {
        const uri = '/veeva/retrieveEquisSubtypePicklist';
        const postData = {
            value: val.value

        }
        const response = await axios.post(process.env.REACT_APP_API + uri, postData);
        setingData(response.data.data.result);
    }


    const setingData = (data)=>{
        const sharingRule = data.properties.find((data)=>data.name === "sharing_rules__c");

        const customer = data.properties.find((data)=>data.name === "customer__c");
        const lifecycle = data.availableLifecycles.find((data)=>data.name === "draft_to_effective_lifecycle__c");

        let  sharingRules=[];
        sharingRule?.entryLabels?.forEach((rowData, index) => {
            sharingRules.push( {label:rowData,value:rowData})
        });
        setShatingRules(sharingRules);


        let  customers=[];
        customer?.entryLabels?.forEach((rowData, index) => {
            customers.push( {label:rowData,value:rowData})
        });
        setCustomer(customers);
        setCreateData(d => update(d, {
             $merge: {lifecycle:lifecycle?.label}
        }))

    }




    const changed =async (val,name) => {
        if (name === "type") {
            setCreateData(d => update(d, {
                equisType: { $merge: { label: val.label,value: val.value } },
                equisSubType: { $merge: { label: "",value: "" } },
                sharingRule: { $merge: { label: "",value: "" } },
                customer: { $merge: { label: "",value: "" } },
                product: { $merge: { label: "",value: "" } },
                $merge: {lifecycle:""}

            }))
            getEquisSubType(val);
        }else if(name === "subType"){
            setCreateData(d => update(d, {
                equisSubType: { $merge: { label: val.label,value: val.value } },
                sharingRule: { $merge: { label: "",value: "" } },
                customer: { $merge: { label: "",value: "" } },
                product: { $merge: { label: "",value: "" } },
                $merge: {lifecycle:""}
            }))
            getEquisSubTypePick(val);
        }else if(name === "subTypePick"){
            setCreateData(d => update(d, {
                equisSubTypePick: { $merge: { label: val.label,value: val.value } },
            }))
        }else if(name === "name"){
            setCreateData(d => update(d, {
                $merge: {name:val}
            }))
        }else if(name === "sharingRule"){
            console.log("val  " , val);
            setCreateData(d => update(d, {
                sharingRule: { $merge: { label: val.label,value: val.value } },
            }))
        }else if(name === "customer"){
            setCreateData(d => update(d, {
                customer: { $merge: { label: val.label,value: val.value } },
                product: { $merge: { label: "",value: "" } },
            }))
            getEquisProductlistByCustomer(val.value);

        }else if(name === "process"){
            setCreateData(d => update(d, {
                process: { $merge: { label: val.label,value: val.value } },
            }))
        }
        else if(name === "plant"){
            setCreateData(d => update(d, {
                plant: { $merge: { label: val.label,value: val.value } },
            }))
        }
        else if(name === "owningDepartment"){
            setCreateData(d => update(d, {
                owningDepartment: { $merge: { label: val.label,value: val.value } },
            }))
        }
        else if(name === "product"){
            setCreateData(d => update(d, {
                product: { $merge: { label: val.label,value: val.value } },
            }))
        }

    }


    return(
        <>
            <div className={"text-right"}>
                <button className={"bpl-btn primary"} onClick={()=>HandleCreateConfrim()}>create</button>
            </div>
            <ul>
                <li><p>Type</p></li>
                <li>
                    <div>
                        <SearchableSelect
                            border={"ON"}
                            search={true}
                            arrow
                            placeholder=""
                            value={createData.equisType?.value}
                            label={createData.equisType?.label}
                            onChange={(val) => {
                                changed(val,"type");
                            }}
                            name=""
                            options={typeList}
                            menuPlacement={"auto"}
                        />
                    </div>
                </li>
                <li><p>Sub Type</p></li>
                <li>
                    <div>
                        <SearchableSelect
                            border={"ON"}
                            search={false}
                            arrow
                            placeholder=""
                            value={createData.equisSubType?.value}
                            label={createData.equisSubType?.label}
                            onChange={(val) => {
                                changed(val,"subType");
                            }}
                            name=""
                            options={subTypeList}
                            menuPlacement={"auto"}
                        />
                    </div>
                </li>
                <li><p>Name</p></li>
                <li><input type="text" onChange={(e) => {changed(e.target.value,"name");}} value={createData.name}></input></li>
                <li><p>Sharing Rules</p></li>
                <li>
                    <div>
                        <SearchableSelect
                            border={"ON"}
                            search={false}
                            arrow
                            placeholder=""
                            value={createData.sharingRule?.value}
                            label={createData.sharingRule?.label}
                            onChange={(val) => {
                                changed(val,"sharingRule");
                            }}
                            options={shatingRules}
                            menuPlacement={"auto"}

                        />
                    </div>
                </li>
                <li><p>Process</p></li>
                <li>
                    <SearchableSelect
                        border={"ON"}
                        search={false}
                        arrow
                        placeholder=""
                        value={createData.process?.value}
                        label={createData.process?.label}
                        onChange={(val) => {
                            changed(val,"process");
                        }}
                        options={equisProcess}
                        menuPlacement={"auto"}
                    />
                </li>
                <li><p>Building</p></li>
                <li>
                    <SearchableSelect
                        border={"ON"}
                        search={false}
                        arrow
                        placeholder=""
                        value={createData.plant?.value}
                        label={createData.plant?.label}
                        onChange={(val) => {
                            changed(val,"plant");
                        }}
                        options={plant}
                        menuPlacement={"auto"}
                    />
                </li>
                <li><p>Owning Department</p></li>
                <li>
                    <SearchableSelect
                        border={"ON"}
                        search={false}
                        arrow
                        placeholder=""
                        value={createData.owningDepartment?.value}
                        label={createData.owningDepartment?.label}
                        onChange={(val) => {
                            changed(val,"owningDepartment");
                        }}
                        options={owningDepartment}
                        menuPlacement={"top"}
                    />
                </li>
                <li><p>Customer</p></li>
                <li>
                    <SearchableSelect
                        border={"ON"}
                        search={false}
                        arrow
                        placeholder=""
                        value={createData.customer?.value}
                        label={createData.customer?.label}
                        onChange={(val) => {
                            changed(val,"customer");
                        }}
                        options={customer}
                        menuPlacement={"top"}
                    />
                </li>
                <li><p>Product</p></li>
                <li>
                    <SearchableSelect
                        border={"ON"}
                        search={false}
                        arrow
                        placeholder=""
                        value={createData.product?.value}
                        label={createData.product?.label}
                        onChange={(val) => {
                            changed(val,"product");
                        }}
                        options={product}
                        menuPlacement={"top"}
                    />
                </li>
                <li><p>LifeCycle</p></li>
                <li><input type="text" value={createData.lifecycle} disabled={true}/></li>
            </ul>
        </>
    )
}

export default React.memo(CteateEquis);